<script lang="ts">
import { AttachmentType } from '@smartsupp/smartsupp-message'
import { setContext } from 'svelte'
import { writable } from 'svelte/store'

import { contentMessageAttachmentKey, type MessageAttachmentContext } from '@/modules/messages'

import MessageAttachmentCards from './MessageAttachmentCards.svelte'
import MessageAttachmentFile from './MessageAttachmentFile.svelte'
import MessageAttachmentImage from './MessageAttachmentImage.svelte'

type Props = {
	context: MessageAttachmentContext
}

let { context }: Props = $props()

let writableAttachmentContext = writable<MessageAttachmentContext>(context)
setContext(contentMessageAttachmentKey, writableAttachmentContext)
$effect(() => {
	$writableAttachmentContext = context
})

let attachment = $derived(context.attachment)
</script>

{#if attachment}
	{#if attachment.type === AttachmentType.File}
		<MessageAttachmentFile />
	{:else if attachment.type === AttachmentType.Image}
		<MessageAttachmentImage />
	{:else if attachment.type === AttachmentType.Cards}
		<MessageAttachmentCards />
	{/if}
{/if}
